<template>
  <v-container>
    <v-row class="mb-2" justify="space-between" no-gutters>
      <v-btn exact text :to="{ name: 'RecipeIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
    </v-row>
    <v-card>
      <v-card-text class="pb-1">
        <v-row align="center" justify="end" no-gutters>
          <v-btn color="success" @click="saveChanges" :disabled="!dataChanged">
            <v-icon small left>fa-save</v-icon>
            Enregistrer les modifications
          </v-btn>
        </v-row>
        <RecipeBulkEditorActions :selected="selected"></RecipeBulkEditorActions>
      </v-card-text>
      <v-card-text class="py-1">
        <ProductBulkEditorFilter
          :name.sync="filter.name"
          :tags.sync="filter.tags"
          :category.sync="filter.category"
          @filter="filterRecipes"
        ></ProductBulkEditorFilter>
      </v-card-text>
      <v-card-text>
        <RecipeBulkEditorGrid
          :data="data"
          :selected.sync="selected"
        ></RecipeBulkEditorGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import ProductBulkEditorFilter from "../components/ProductBulkEditorFilter";
import RecipeBulkEditorGrid from "../components/RecipeBulkEditorGrid";
import RecipeBulkEditorActions from "../components/RecipeBulkEditorActions";
export default {
  name: "RecipeBulkEditor",
  components: {
    ProductBulkEditorFilter,
    RecipeBulkEditorGrid,
    RecipeBulkEditorActions
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getRecipes", "getTagCategories"]),
    dataChanged() {
      return this.data.map(x => x.is_changed).includes(true);
    }
  },
  data() {
    return {
      data: [],
      selected: [],
      filter: {
        name: null,
        tags: [],
        category: null
      },
      loading: false
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        this.loading = true;
        this.$store.dispatch("loadAllRecipeStore");
        this.$store.dispatch("loadTagCategories");
        const res = await api.getRecipes();
        this.data = res.map(x => {
          return {
            ...x,
            show: true,
            is_changed: false
          };
        });
      } finally {
        this.$store.dispatch("elo");
        this.loading = false;
      }
    },
    filterRecipes() {
      this.$store.dispatch("slo");
      const categoryIsNull =
        this.filter.category === null || this.filter.category === "";
      const nameIsNull = this.filter.name === null || this.filter.name === "";
      const tagsIsEmpty = this.filter.tags.length === 0;
      let normalizeSearch = "";
      if (!nameIsNull) {
        normalizeSearch = this.filter.name
          .toLowerCase()
          .replace(/\s/g, "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");
      }

      this.data.forEach(x => {
        if (categoryIsNull && nameIsNull && tagsIsEmpty) {
          x.show = true;
        } else {
          let inCategory = true;
          let inName = true;
          let inTags = true;
          if (!categoryIsNull) {
            inCategory = false;
            const category = this.getTagCategories.find(
              c => c.id === this.filter.category
            );
            if (category) {
              inCategory = x.data.tags.some(t => category.tags.includes(t));
            }
          }
          if (!tagsIsEmpty) {
            inTags = this.filter.tags.every(t => x.data.tags.includes(t));
          }
          if (!nameIsNull) {
            inName = false;
            const itemName = x.nom
              .toLowerCase()
              .replace(/\s/g, "")
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
            const itemKey =
              x.data && x.data.recipe_key !== null
                ? x.data.recipe_key
                    .toLowerCase()
                    .replace(/\s/g, "")
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                : null;

            if (itemName.indexOf(normalizeSearch) !== -1) {
              inName = true;
            } else if (
              itemKey !== null &&
              itemKey.indexOf(normalizeSearch) !== -1
            ) {
              inName = true;
            }
          }
          x.show = inCategory && inName && inTags;
        }
      });
      this.$store.dispatch("elo");
    },
    async saveChanges() {
      try {
        this.$store.dispatch("slo");
        const tasks = [];
        this.data
          .filter(x => x.is_changed === true)
          .forEach(x => {
            tasks.push(api.putRecipe(x.id, x));
          });
        await Promise.all(tasks);
        const res = await api.getRecipes();
        this.data = res.map(x => {
          return {
            ...x,
            show: true,
            is_changed: false
          };
        });
        this.filterRecipes();
      } finally {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
